import { Extension } from '@tiptap/core'
import { variableHighlightPlugin } from './variable-highlight-plugin'

export const VariableHighlight = Extension.create({
  name: 'variableHighlight',

  addProseMirrorPlugins() {
    return [variableHighlightPlugin]
  },
})
